import script from "./DetailEventTamu.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailEventTamu.vue?vue&type=script&setup=true&lang=js"

import "./DetailEventTamu.vue?vue&type=style&index=0&id=4436d974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4436d974"]])

export default __exports__